import { PriceTrendFilterProps } from "../types";
import classes from "../PriceTrend.module.scss";
import RoomTypeFilterDesktop from "./Filters/RoomTypeFilterDesktop";
import RoomTypeFilter from "./Filters/RoomTypeFilter";
import useTranslationHook from "hooks/useTranslationHook";
import wrapperHOC from "@Utils/wrapperHOC";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
//

const PriceTrendFilter = ({
  selectedConfig,
  isSelected,
  roomTypes,
  handleReset,
  handleFilterChange,
  isDesktop = false,
}: PriceTrendFilterProps) => {
  const { t } = useTranslationHook();

  return (
    <>
      {roomTypes?.length > 0 ? (
        <div className={formatClassNames(classes.filterContainer, isDesktop && classes.desktop)}>
          {isDesktop ? (
            <RoomTypeFilterDesktop
              selectedConfig={selectedConfig}
              roomTypes={roomTypes}
              isSelected={isSelected}
              handleFilterChange={handleFilterChange}
            />
          ) : (
            <RoomTypeFilter
              selectedConfig={selectedConfig}
              roomTypes={roomTypes}
              isSelected={isSelected}
              handleFilterChange={handleFilterChange}
            />
          )}
          <button
            data-testid="Reset"
            type="button"
            onClick={handleReset}
            disabled={!isSelected}
            className={classes.reset}
          >
            {t("propertypage.roomtypesectiondynamic.reset")}
          </button>
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default wrapperHOC(PriceTrendFilter, {
  componentName: "PriceTrendFilter-PriceTrends-PropertyPage",
  showForChina: true,
});
